import {useQueries} from "@tanstack/react-query";
import locationService from "../../../../../services/web/location-service.js";
import contactIdService from "../../../../../services/web/contact-id-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['locationTypes'],
                queryFn: () => locationService.getLocationType().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['lastEvent'],
                queryFn: () => contactIdService.lastEvent().then(({data}) => data.map(({id, text}) => ({value: id, label: text})))
            },
        ]
    });

    return {
        locationTypes: queries[0].data ?? [],
        lastEvent: queries[1].data ?? [],
    }
};

export default UseFetchData;
